<script type="text/jsx">
import Add from './add';
import Edit from './edit';
import BuyNow from './buy-now';
import planPropsMixin from '@/plans/mx/plan-props';
import Zs2Ze from '@/plans/EVENT_SAAS/config/Zs2Ze.vue';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.zs2ze) return <Zs2Ze {...context} />;
    return <BuyNow {...context} />;
  },
};
</script>
